import type { DomainMapper } from '../types';

const base = {
  countryCode: 'fr',
  currency: 'EUR',
  dataAreaId: 'fr36',
  environment: 'production',
  flagUrl: '/flags/FR.svg',
  languagePrimary: true,
  locale: 'fr',
  logoUrl: 'kahrs-logo',
  noRobots: false,
  productBasePath: 'produit',
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-fr.xml',
  storyblokBasePath: 'fr',
  algoliaIndex: 'b2b-fr-fr-FR-products',
  algoliaIndexAutocomplete: 'b2b-fr-fr-FR-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1617,
  subFolder: true,
  googleSiteVerification: 'tHG4C4vnMgMxfElDcGevBx5-SKSflV4V5W_Rn6Ao8rM',
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1617,
    algoliaIndex: 'b2b-fr-fr-FR-products',
    algoliaIndexAutocomplete: 'b2b-fr-fr-FR-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/produit',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-fr.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1647,
    algoliaIndex: 'b2c-fr-fr-FR-products',
    algoliaIndexAutocomplete: 'b2c-fr-fr-FR-products_query_suggestions',
    displayIncVat: true,
    default: false,
    productBasePath: 'produit',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-fr-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    sampleRequestNav: true,
    onlyAllowCustomerEditAddressesForSamples: true,
    disableShipToConsumer: true,
  },
  showNonPublicProducts: false,
};

const fr: DomainMapper[] = ['new.kahrs.com', 'www.kahrs.com'].map((domain) => ({
  ...base,
  domain,
  legacyDomain: domain === 'new.kahrs.com',
  url: `https://${domain}/${base.storyblokBasePath}`,
} as DomainMapper));

export default fr;
